module.exports = __webpack_public_path__ + "assets/daima.4ee4230e.svg";